import { useEffect } from "react";
import { useT } from "../i18n/index.js";
import { serverNow } from "../state/serverTime.js";
import { Button } from "../ui/Button.js";
import { Panel } from "../ui/Panel.js";
import { Icon } from "../ui/Icon.js";
import { formatDuration } from "../ui/Timer.js";
import { useAlliance } from "./state.js";

/** Gifts tab (D72): open alliance gifts, each claimable once, gone after 24 hours. */
export function Gifts() {
  const t = useT();
  const gifts = useAlliance((s) => s.gifts);
  const refreshGifts = useAlliance((s) => s.refreshGifts);
  const claimGift = useAlliance((s) => s.claimGift);
  useEffect(() => {
    void refreshGifts();
  }, [refreshGifts]);
  const now = serverNow();
  if (!gifts) return <p className="hint" style={{ padding: 12 }}>{t("common.loading")}</p>;
  return (
    <div className="alliance-gifts" data-testid="alliance-gifts">
      <Panel title={t("alliance.gifts.title")}>
        <p className="hint">{t("alliance.gifts.hint")}</p>
        {gifts.open.length === 0 ? <p className="hint" data-testid="gifts-none">{t("alliance.gifts.none")}</p> : null}
        {gifts.open.map((g) => (
          <div key={g.id} className={`alliance-row gift-${g.tier}`} data-testid={`gift-${g.id}`}>
            <span className={`badge gift-tier-${g.tier}`}>{t(`alliance.gifts.tier.${g.tier}`)}</span>
            <div className="grow" style={{ minWidth: 0 }}>
              <strong className="ellipsis">{t(`alliance.gifts.source.${g.source}`, { name: g.sourceName })}</strong>
              <div className="hint"><Icon name="clock" /> {formatDuration(Math.max(0, g.expiresAt - now))}</div>
            </div>
            <Button variant={g.claimed ? "default" : "gold"} disabled={g.claimed} onClick={() => void claimGift(g.id)} data-testid={`gift-claim-${g.id}`}>
              {g.claimed ? t("alliance.gifts.claimed") : t("alliance.gifts.claim")}
            </Button>
          </div>
        ))}
      </Panel>
    </div>
  );
}
